<script setup lang="ts">
function close() {
  document.body.classList.remove('show-vo-rita-modal');
}
</script>
<template>
  <div class="bg-white fixed w-full h-full vo-rita-modal overflow-y-auto">
    <div class="w-11/12 bg-slate-300 xl:min-h-screen block mx-auto">
      <!-- Section -->
       <div class="block mx-auto">
        <!-- Header -->
          <div class="flex justify-between py-8">
            <div></div>
            <button class="text-lg font-bold hover:underline" @click="close">
              {{ $t('BACK')}} X
            </button>
          </div>
          <div class="flex hero-section items-stretch content-stretch justify-end flex-col lg:flex-row relative 2xl:flex-nowrap">
            <div class="flex-1 flex items-center mb-6 mx-6 xl:mb-0">
              <div class="xl:w-9/12 ml-auto block xl:mr-10">
                <p class="text-4xl xl:text-6xl highlight text-justify my-8">
                  {{ $t('WHO_IS_VO_RITA') }}
                </p>
                <p class="text-2xl">
                  "Preta velha que nos assiste e abriu caminho para as demais entidades trabalharem"
                </p>
              </div>
            </div>
            <div class="relative flex items-end vo-rita-img-container justify-end">
              <div>
                <!-- Image -->
                <img :src="$config.public.assetsUrl + '/about/vo-rita.jpg'" alt="Imagem de uma Preta Velha sentada em frente ao Altar" class="vo-rita-img">
              </div>
            </div>
          </div>
       </div>
    </div>

    <!-- Content -->
    <div class="content w-11/12 block mx-auto pt-32">
      <div class="block mx-auto w-11/12 lg:w-10/12 2xl:w-8/12 text-2xl">
        <p class="text-lg whitespace-break-spaces full-text text-justify pb-10">
          Preta velha que nos assiste, abriu caminho para as demais entidades trabalharem.<br><br>
          Vó Rita das Almas se apresenta no terreiro esporadicamente, deixando que o Vô Celestiano, preto velho que também nos assiste atenda a assistência. No entanto quando Vó Rita das Almas se manifesta, sua energia é maravilhosa e purificadora.<br><br>

          Vó Rita das Almas se mostrou visualmente para este signatário, Pai Noé de Xangô pela primeira vez quando tínhamos cinco anos de idade e na época nos disse que iria nos acompanhar durante nossa jornada terrena.<br><br>

          Vó Rita das Almas é quem conduz os trabalhos de Umbanda e se apresenta como preta velha e na Psicografia como Irmã Rosália quando se identifica nas cartas consoladoras por ocasião dos recados que são dirigidos a quem solicita Carta do ente querido, dissertando o porquê o espirito não pode escrever naquele momento. <br><br>
          Com ponto riscado e firmado Vó Rita das Almas trabalha com as Almas benditas e iluminadas na pratica do bem e da caridade, não permitindo que vaidades possam prejudicar a corrente mediúnica.<br><br>

          Vó Rita das Almas não permite que médiuns quando incorporados ingiram bebida alcoólica durante as giras de Umbanda no terreiro, em hipótese alguma.<br><br>
          No terreiro Vó Rita das Almas as entidades manipulam energeticamente o etílico, pois no astral quando manipuladas de forma seria, as bebidas funcionam como desagregadoras e desestabilizadoras de energia perniciosas, agindo de modo vigoroso e positivo no campo elétrico e magnético do mundo oculto, pois além de expulsar os espíritos malfeitores desobstrui as cortinas de miasmas estagnadas em ambientes enfermiços.<br><br>

          Vó Rita das Almas permite que os espíritos trabalhadores na seara do bem, façam o uso da fumaça como depurador das energias, fumaça dos cachimbos, charutos, cigarros de palha, da defumação etc...<br>
          <br>
          
          Salve os Pretos velhos!<br>
          Salve Vó Rita das Almas!<br>
          Salve a Umbanda!
        </p>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.hero-section img {
  border-top-left-radius: 250px;
  width: 85%;
  margin-bottom: -40px;
  max-width: 650px;
}

.vo-rita-img-container {
  pointer-events: none;

  div {
    height: 50%;
    min-height: 650px;
  }

  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
}
.content {
  background-color: #f2f0ef;
}

.hero-section {
  min-height: calc(100vh - 132px);
}

.vo-rita-modal {
  z-index: 1000 !important;
  line-height: 1;
  transform: scale(1.1);
  opacity: 0;
  visibility: hidden;

  .full-text {
    line-height: 1.8;
  }

  .highlight {
    line-height: 1.5;
  }
}


@media (screen(lg)) {
  .vo-rita-img-container div {
    transform: translateX(52px);
  }
}

@media (screen(xl)) {
  .vo-rita-img-container div {
    transform: translateX(60px);
  }
}

@media screen and (max-width: 1532px) {
  .hero-section {
    min-height: 700px !important;
    height: unset !important;
  }

  .vo-rita-img-container {
    div {
      height: 480px;
    }
  }
}

@media (screen(2xl)) {
  .vo-rita-img-container {
    width: 600px;

    div {
      transform: translateX(19%);
    }
    
  }
}

@media (screen(xl)) {
  .hero-section {
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>